import './update-banner.styles.scss';

export default angular.module('directives.abUpdateBanner', [])
  .directive('abUpdateBanner', () => {
    'ngInject';

    return {
      restrict: 'E',
      templateUrl: require('./update-banner.template.html'),
    };
  })
  .name;
